import React from 'react';
import DesktopCards from './DesktopCards';
import MobileTable from './MobileTable';
import UpgradeDisclaimer from './UpgradeDisclaimer';
import UpgradeButton from './UpgradeButton';
import { getImagesStaticUrl } from '../../helpers';
import { useUpgradeMembershipContext } from '../../utils/ContextProviders/UpgradeContext';
import type { BaseUpgradePageProps } from '../UpgradeRedesign';
import './styles.css';
import { CouponCodeField } from '../../components/CouponCodeField';

interface UpgradePageProps extends BaseUpgradePageProps {
  flags?: any;
  ldClient?: any;
}

const Upgrade = ({
  flags,
  onSubmitSubscription,
  getCouponContentKey,
  hCaptcha,
  couponProps,
}: UpgradePageProps) => {
  const { growthUpgrade } = useUpgradeMembershipContext();
  const { displayAdditionalPerks } = flags || {};
  const { variables } = growthUpgrade;
  return (
    <>
      <div id="content" className="site-content">
        <div
          className="upgrade-background-banner"
          style={{
            backgroundImage: `url(${getImagesStaticUrl(
              getCouponContentKey(
                'upgradeBackgroundBannerImage',
                'hero-desktop.png'
              )
            )})`,
          }}
        >
          <img
            className="background-banner-wave"
            src={getImagesStaticUrl(
              getCouponContentKey(
                'backgroundBannerWaveImage',
                'upgrade-wave.svg'
              )
            )}
            alt="background"
          />
        </div>
        <div
          className="upgrade-row upgrade-container"
          style={{ position: 'relative' }}
        >
          <div className="upgrade-col padding-none">
            <div className="page-content">
              <article className="page">
                <div className="upgrade-confirmation-container">
                  <div className="head text-center">{variables?.heading}</div>
                  <div className="sub-head text-center">
                    {variables?.subheading}
                  </div>
                  <DesktopCards
                    showAdditionalPerks={displayAdditionalPerks}
                    getCouponContentKey={getCouponContentKey}
                  />
                  <MobileTable
                    showAdditionalPerks={displayAdditionalPerks}
                    getCouponContentKey={getCouponContentKey}
                  />
                  <div className="upgrade-coupon-code">
                    <CouponCodeField {...couponProps} />
                  </div>
                  <div className="acceptance-container">
                    <UpgradeDisclaimer />
                    <UpgradeButton
                      onClickUpgrade={onSubmitSubscription}
                      getCouponContentKey={getCouponContentKey}
                    >
                      {hCaptcha}
                    </UpgradeButton>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Upgrade;
